export const GET_SERVICE_PROVIDER_APPOINTMENTS_LIST = null;
export const SELECTED_APPOINTMENT_DATE = null;
export const SELECTED_APPOINTMENTS_INFO_ID = null;
export const SELECTED_SERVICE_PROVIDER_APPOINTMENT_ID = null;
export const SELECTED_CALENDAR_APPOINTMENT_ID = null;
export const SELECTED_SERVICE_ID_FOR_PACKAGE = null;
export const SELECTED_APPOINTMENT_ORDER_TYPE = null;
export const SELECTED_APPOINTMENT_PACKAGE_SERVICE_ID = null;